import axios from "axios";
import Swal from "sweetalert2";

const HandleSingleWasteInventory = async ({
  inventoryId,
  instanceIndex,
  quantity,
  token,
  fetchInventory,
  onClose,
}) => {
  try {
    await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/v1/api/inventory/waste`,
      {
        inventoryId,
        quantity,
        instanceIndex,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    Swal.fire("Success", "Waste recorded successfully.", "success");
    if (fetchInventory) await fetchInventory();
    if (onClose) onClose();
  } catch (error) {
    console.error("Error in HandleSingleWasteInventory:", error);
    Swal.fire(
      "Error",
      error.response?.data?.message || "Failed to record waste.",
      "error"
    );
  }
};

export default HandleSingleWasteInventory;
